import { inject, Injectable } from '@angular/core';
import { INotification } from './notification-factory.service';
import { PushNotificationService } from './push-notification.service';
import { MessageTemplate } from '../../models/enums/enums';
import { CalendlyService } from '../calendly/calendly.service';

@Injectable({
  providedIn: 'root'
})
export class MeetingScheduledNotificationService implements INotification {
  constructor(
    private pushNotificationService: PushNotificationService,
    private calendlyService: CalendlyService
  ) {}

  notify(message:string,data: { [key: string]: any }): void {
    this.pushNotificationService.pushNotification(message,MessageTemplate.MeetingScheduled, data);

    if (data['notifyTo'] === 'student') {
      this.calendlyService.schduledMeetingForStudent$.next(data['scheduledCallsForStudentResponse']);
    }

    if (data['notifyTo'] === 'mentor') {
      this.calendlyService.schduledMeetingForMentor$.next(data['scheduledMeetingResponse']);
    }
  }
}
